export const setAdvanceFilter = (payload) => {
	return {
		type: 'SET_ADVANCE_FILTER',
		payload: payload,
	};
};
export const setAdvanceFilterTotalPage = (payload) => {
	return {
		type: 'SET_ADVANCE_FILTER_TOTAL_PAGE',
		payload: payload,
	};
};

export const setSelectedInput = (payload) => {
	return {
		type: 'SET_SELECTED_INPUT',
		payload: payload,
	};
};

export const setSelectedInputValue = (payload) => {
	return {
		type: 'SET_SELECTED_INPUT_VALUE',
		payload: payload,
	};
};

export const setSelectedInputData = (payload) => {
	return {
		type: 'SET_SELECTED_INPUT_DATA',
		payload: payload,
	};
};

export const setAdvanceFilterPage = (payload) => {
	return {
		type: 'SET_PAGE',
		payload: payload,
	};
};

export const removeSelectedInput = (payload) => {
	return {
		type: 'REMOVE_SELECTED_INPUT',
		payload,
	};
};
export const clearAdvanceFilter = () => {
	return {
		type: 'CLEAR_ADVANCE_FILTER',
	};
};

export const updateVendorAdvanceFilter = (payload) => {
	return {
		type: 'SET_VENDOR_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearVendorAdvanceFilter = () => {
	return {
		type: 'CLEAR_VENDOR_ADVANCE_FILTER',
	};
};
export const updatePOAdvanceFilter = (payload) => {
	return {
		type: 'SET_PO_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearPOAdvanceFilter = () => {
	return {
		type: 'CLEAR_PO_ADVANCE_FILTER',
	};
};
export const updatePRAdvanceFilter = (payload) => {
	return {
		type: 'SET_PR_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearPRAdvanceFilter = () => {
	return {
		type: 'CLEAR_PR_ADVANCE_FILTER',
	};
};
export const updatePBAdvanceFilter = (payload) => {
	return {
		type: 'SET_PB_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearPBAdvanceFilter = () => {
	return {
		type: 'CLEAR_PB_ADVANCE_FILTER',
	};
};
export const updatePMAdvanceFilter = (payload) => {
	return {
		type: 'SET_PM_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearPMAdvanceFilter = () => {
	return {
		type: 'CLEAR_PM_ADVANCE_FILTER',
	};
};
export const updateCNAdvanceFilter = (payload) => {
	return {
		type: 'SET_CN_ADVANCE_FILTER',
		payload: payload,
	};
};

export const clearCNAdvanceFilter = () => {
	return {
		type: 'CLEAR_CN_ADVANCE_FILTER',
	};
};
